import { Injectable, signal } from '@angular/core';

/**
 * Service zum Zwischenspeichern von Bild-Dateien für den Announcement-Editor.
 *
 * File-Objekte sind nicht JSON-serialisierbar und dürfen daher nicht
 * in ngrx-Actions übergeben werden (strictActionSerializability).
 * Dieser Service hält die Datei temporär und wird vom Effect konsumiert.
 */
@Injectable({ providedIn: 'root' })
export class AnnouncementImageStagingService {
  private readonly _pendingImageFile = signal<File | null>(null);
  private readonly _pendingImageDeleted = signal<boolean>(false);

  /**
   * Stellt eine Bild-Datei und den Lösch-Status für den nächsten Save-Vorgang bereit.
   */
  stage(imageFile: File | null, imageDeleted: boolean): void {
    this._pendingImageFile.set(imageFile);
    this._pendingImageDeleted.set(imageDeleted);
  }

  /**
   * Konsumiert die gestagten Daten und setzt sie zurück.
   * Sollte genau einmal pro Save-Vorgang aufgerufen werden (im Effect).
   */
  consume(): { imageFile: File | null; imageDeleted: boolean } {
    const result = {
      imageFile: this._pendingImageFile(),
      imageDeleted: this._pendingImageDeleted(),
    };
    this._pendingImageFile.set(null);
    this._pendingImageDeleted.set(false);
    return result;
  }
}
